import * as Sentry from '@sentry/astro';
import { captureConsoleIntegration } from '@sentry/astro';

Sentry.init({
    dsn: 'https://adafd2025a1ef0315cce113f0420df70@sentry.mcorecode.com/22',

    tracesSampleRate: 0.7,

    integrations: [captureConsoleIntegration({ levels: ['warn', 'error', 'assert'] })],

    environment: import.meta.env.NODE_ENV,

    debug: false,
    autoSessionTracking: true,
});
